import React from 'react';

import { FieldOption } from './Option.styles';

const Option = ({ key, label, value, ...rest }) => (
  <FieldOption key={key} value={value} {...rest}>
    {label}
  </FieldOption>
);

export default Option;
